const PrivacyPolicy = '';
const TermsAndConditions = '';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
